import { SDK_VERSION as r } from "./chunk887.js";
const l = globalThis;
function S(_, e, i) {
  const o = i || l, t = o.__SENTRY__ = o.__SENTRY__ || {}, n = t[r] = t[r] || {};
  return n[_] || (n[_] = e());
}
export {
  l as GLOBAL_OBJ,
  S as getGlobalSingleton
};
